import React, { useState } from "react";
import ItemRow from "./Rows/ItemRow";
import MainRow from "./Rows/MainRow";

interface Props {
    elements: any[];
    isVisible: boolean;
    name: string;
    onChange: (path: string, value) => void;
    onDelete: () => void;
    onDeleteItem: (index) => void;
    onAddItems: () => void;
    onDragItem: (e, path: string) => void;
    onDropItem: (e, path: string) => void;
    onDrag: (e) => void;
    onDrop: (e) => void;
}

const SubHeaderQuote: React.FC<Props> = (props) => {
    const [isExpand, setIsExpand] = useState(true);
    const { elements, isVisible, name, onChange, onDelete, onDeleteItem, onAddItems, onDropItem, onDragItem, onDrop, onDrag} = props;

    const handleAddItems = () => {
        setIsExpand(true)
        onAddItems();
    }

    return (
        <>
            <MainRow name={name} isExpand={isExpand} isVisible={isVisible} isSubRow onExpand={() => setIsExpand((prev) => !prev)} onChange={onChange} onDelete={onDelete} onAddItems={handleAddItems} onDrop={onDrop} onDrag={onDrag}/>
            {elements?.map((e, index) =>
                <ItemRow
                    isVisible={isVisible && isExpand} 
                    isSubRow 
                    item={e} 
                    onChange={(name, value) => onChange(`elements.${index}.${name}`, value)} 
                    onDelete={() => onDeleteItem(index)} 
                    onDrag = {(e) => onDragItem(e,`elements.${index}`)}
                    onDrop = {(e) => onDropItem(e,`elements.${index}`)} 
                    />
            )}
        </>
    );
};

export default SubHeaderQuote;